import React from 'react';
import { Box, Typography } from '@mui/material';
import HubIcon from '@mui/icons-material/Hub';
import { mvkgTokens } from '../../theme/mvkgTokens';

const SIZES = {
  sm: { box: 32, icon: 18, text: '1rem',    sub: '0.6rem' },
  md: { box: 40, icon: 22, text: '1.15rem', sub: '0.65rem' },
  lg: { box: 56, icon: 30, text: '1.6rem',  sub: '0.7rem' },
};

/** Brand mark: indigo rounded square + "MVKG" wordmark + optional tagline. */
export default function Logo({ size = 'md', tagline = false, white = false, sx = {} }) {
  const s = SIZES[size] || SIZES.md;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, ...sx }}>
      <Box
        sx={{
          width: s.box,
          height: s.box,
          borderRadius: `${mvkgTokens.radius.md}px`,
          background: mvkgTokens.gradient.brand,
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: mvkgTokens.shadow.brandSm,
          flexShrink: 0,
        }}
      >
        <HubIcon sx={{ fontSize: s.icon }} />
      </Box>
      <Box sx={{ lineHeight: 1.1, minWidth: 0 }}>
        <Typography
          sx={{
            fontFamily: mvkgTokens.font.display,
            fontWeight: 700,
            fontSize: s.text,
            letterSpacing: '-0.02em',
            color: white ? '#fff' : 'text.primary',
          }}
        >
          MVKG
        </Typography>
        {tagline && (
          <Typography
            sx={{
              fontFamily: mvkgTokens.font.mono,
              fontSize: s.sub,
              letterSpacing: '0.16em',
              textTransform: 'uppercase',
              color: white ? 'rgba(255,255,255,0.7)' : 'text.secondary',
            }}
          >
            Read smarter
          </Typography>
        )}
      </Box>
    </Box>
  );
}
